import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { EMPTY_MEMBER_DATA } from '../../constants';
import * as Styled from './styles';
import type { AddMoreMemberButtonProps as Props } from './types';

export const AddMoreMemberButton = memo(
  ({ className, onAppend, loading, ...props }: Props) => {
    const handleAddNewRow = () => onAppend(EMPTY_MEMBER_DATA);
    const form = useFormContext();

    return (
      <Styled.Wrapper
        className={classnames('AddMoreMemberButton', className)}
        disabled={!form.formState.isValid || loading}
        variant="outlined"
        color="primary"
        size="small"
        {...props}
        onClick={handleAddNewRow}
        startIcon={<Icon name="plus" size={24} />}
      >
        Add More
      </Styled.Wrapper>
    );
  }
);

AddMoreMemberButton.displayName = 'AddMoreMemberButton';
